// @flow
/* global SETTINGS: false */
// constants for fetch status (these are not action types)
export const FETCH_FAILURE = "FETCH_FAILURE"
export const FETCH_SUCCESS = "FETCH_SUCCESS"
export const FETCH_PROCESSING = "FETCH_PROCESSING"

// Checkout functionality removed (paid upgrades discontinued)
